import { CourseStatus } from '../../../../../../../shared/interfaces/src';
import { Filter } from './filter';

export class CourseStatusFilter extends Filter<boolean, (CourseStatus | false)[] | undefined> {
    constructor() {
        super(null, false);
    }

    protected inputValueFromFilterValue(filterValue: (CourseStatus | false)[] | undefined): boolean {
        return filterValue?.includes(CourseStatus.DEPRECATED) ?? false;
    }

    protected filterValueFromInputValue(inputValue: boolean): (CourseStatus | false)[] | undefined {
        return inputValue ? [CourseStatus.DEPRECATED] : undefined;
    }
}
